import { extend } from 'flarum/common/extend';
import Stream from 'flarum/common/utils/Stream';
import BirthdayField from './components/BirthdayField';
export default function addEditUserField() {
  extend('flarum/common/components/EditUserModal', 'oninit', function () {
    this.birthday = Stream(this.attrs.user.birthday() || '');
  });
  extend('flarum/common/components/EditUserModal', 'fields', function (items) {
    if (!this.attrs.user.canEditBirthday()) return;
    items.add('birthday', m(BirthdayField, {
      stream: this.birthday,
      disabled: this.loading
    }), 25);
  });
  extend('flarum/common/components/EditUserModal', 'data', function (data) {
    if (!this.attrs.user.canEditBirthday()) return;
    const birthday = this.birthday() || null;
    if (birthday !== (this.attrs.user.birthday() ?? null)) {
      data.birthday = birthday;
    }
  });
}
flarum.reg.add('datlechin-birthdays', 'common/addEditUserField', addEditUserField);